import { render, staticRenderFns } from "./ProfilDaerahMainTable.vue?vue&type=template&id=40de724f&scoped=true"
import script from "./ProfilDaerahMainTable.vue?vue&type=script&lang=js"
export * from "./ProfilDaerahMainTable.vue?vue&type=script&lang=js"
import style0 from "./ProfilDaerahMainTable.vue?vue&type=style&index=0&id=40de724f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40de724f",
  null
  
)

export default component.exports